import request from '@/router/axios';

// 查询设备管理列表
export const getList = (params) => {
    return request({
        url: '/api/produce/base-device-manage/select/page',
        method: 'post',
        params
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/base-device-manage/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const add = (row) => {
    return request({
        url: '/api/produce/base-device-manage/insert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/base-device-manage/update',
        method: 'post',
        data: row
    })
}


// 删除设备
export const remove = (id) => {
    return request({
        url: "/api/produce/base-device-manage/delete/id",
        method: "get",
        params: {
            id
        }
    });
};

/** 导出 Excel（查询条件与列表接口一致，不分页导出全部匹配行） */
export const exportExcel = (params) => {
    return request({
        url: '/api/produce/base-device-manage/export/excel',
        method: 'post',
        params,
        responseType: 'blob'
    })
}

/** 下载导入模板（列与导出一致，安装位置列为字典下拉） */
export const downloadImportTemplate = () => {
    return request({
        url: '/api/produce/base-device-manage/export/import-template',
        method: 'get',
        responseType: 'blob'
    })
}

export const importExcel = (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return request({
        url: '/api/produce/base-device-manage/upload/excel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const uploadManual = (deviceId, file) => {
    const formData = new FormData()
    formData.append('deviceId', deviceId)
    formData.append('file', file)
    return request({
        url: '/api/produce/base-device-manual/upload',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const getCurrentManual = (deviceId) => request({
    url: '/api/produce/base-device-manual/current',
    method: 'get',
    params: { deviceId }
})

export const getManualList = (params) => request({
    url: '/api/produce/base-device-manual/select/page',
    method: 'post',
    params
})

export const getChapterTree = (manualId) => request({
    url: '/api/produce/base-device-manual/chapter/tree',
    method: 'get',
    params: { manualId }
})

export const getChapterContent = (manualId, chapterId) => request({
    url: '/api/produce/base-device-manual/chapter/content',
    method: 'get',
    params: { manualId, chapterId }
})

export const searchManual = (params) => request({
    url: '/api/produce/base-device-manual/search/page',
    method: 'post',
    params
})

export const downloadManual = (id) => request({
    url: '/api/produce/base-device-manual/download',
    method: 'get',
    params: { id }
})

export const deleteManual = (id) => request({
    url: '/api/produce/base-device-manual/delete/id',
    method: 'get',
    params: { id }
})

export const reparseManual = (id) => request({
    url: '/api/produce/base-device-manual/reparse',
    method: 'post',
    params: { id }
})
